import { AutomationActionType, CandidateStatus } from 'generated-graphql/types';
import React from 'react';
import { CampaignSearchSelector } from './CampaignSearchSelector';
import { AutomationMessagePreview } from './AutomationMessagePreview';
import { AtsUpdateSelector } from 'services/automation/components/AtsUpdateSelector';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

type Props = {
  index: number;
  actionType: AutomationActionType;
  analysisAutomationItem: AutomationFormItem;
  candidateBatchId?: string;
  setFieldValue: (field: string, value: any) => void;
  candidateStatus?: string | null;
  atsJobId?: string | null;
  errorType?: 'campaign' | 'ats';
  onCampaignStatusChange?: (status: string | undefined) => void;
};

export const ActionTypeComponentLoader: React.FC<Props> = ({
  index,
  actionType,
  analysisAutomationItem,
  setFieldValue,
  candidateBatchId,
  candidateStatus,
  atsJobId,
  errorType,
  onCampaignStatusChange
}) => {
  if (actionType === AutomationActionType.SendCampaign) {
    return (
      <CampaignSearchSelector
        candidateBatchId={candidateBatchId}
        index={index}
        analysisAutomationItem={analysisAutomationItem}
        setFieldValue={setFieldValue}
        error={errorType === 'campaign'}
        onCampaignStatusChange={onCampaignStatusChange}
      />
    );
  }
  if (
    actionType === AutomationActionType.SendEmail ||
    actionType === AutomationActionType.SendJobRecommendationEmail
  ) {
    return (
      <AutomationMessagePreview
        index={index}
        analysisAutomationItem={analysisAutomationItem}
        automationActionType={actionType}
        setFieldValue={setFieldValue}
      />
    );
  }
  if (actionType === AutomationActionType.UpdateAts && candidateStatus) {
    return (
      <AtsUpdateSelector
        atsJobId={atsJobId}
        isRejectionMode={candidateStatus === CandidateStatus.Rejected}
        setAtsInterviewStageId={(value) => {
          setFieldValue(`[${index}].action.atsInterviewStageId`, value);
        }}
        setAtsRejectedReasonId={(value) => {
          setFieldValue(`[${index}].action.atsRejectedReasonId`, value);
        }}
        setKomboStageId={(value) => {
          setFieldValue(`[${index}].action.komboStageId`, value);
        }}
        setKomboRejectionReasonId={(value) => {
          setFieldValue(`[${index}].action.komboRejectionReasonId`, value);
        }}
        atsInterviewStageId={analysisAutomationItem.action.atsInterviewStageId}
        atsRejectedReasonId={analysisAutomationItem.action.atsRejectedReasonId}
        komboStageId={analysisAutomationItem.action.komboStageId}
        komboRejectionReasonId={
          analysisAutomationItem.action.komboRejectionReasonId
        }
        error={errorType === 'ats'}
      />
    );
  }

  return null;
};
